module.exports = __webpack_public_path__ + "static/media/quote-left.cc73ac9f.svg";